import { RouteComponentProps } from 'react-router-dom';
import withRoute from '@/pages/withRoute';
import BookingsPage from './BookingsPage';

export const prefix = 'bm-p-bookings';

const RouteComponent: React.FC<RouteComponentProps> = props => withRoute({
  pageComponent: BookingsPage,
  routeProps: props,
  pageTitleI18nKey: '',
});
export default RouteComponent;
